import { createSelector } from '@reduxjs/toolkit';
import { CountryISOCodes } from 'common/countries';
import { RootState } from 'state/store';

import { getCurrencyByCountry } from 'utils/currency';

export const getRoot = (state: RootState) => state.businessPlan;
export const getProfile = (state: RootState) => state.profile;
export const getDashboardDropdowns = (state: RootState) =>
  state.dashboard.dropdowns;

export const getStep = createSelector([getRoot], ({ step }) => step);

export const getStepsLength = createSelector(
  [getRoot],
  ({ stepsLength }) => stepsLength,
);

export const getPlanAttachedState = createSelector(
  [getRoot],
  ({ isPlanAttached }) => isPlanAttached,
);

export const getprogressPercent = createSelector(
  [getRoot],
  ({ progressPercent }) => progressPercent,
);

export const getFiles = createSelector([getRoot], ({ files }) =>
  files.filter(({ isActive }) => isActive),
);

export const getlogoFiles = createSelector([getRoot], ({ logoFiles }) =>
  logoFiles.filter(({ isActive }) => isActive),
);

export const getBusinessPlan = createSelector(
  [getRoot],
  ({ businessPlan }) => businessPlan,
);

export const getBusinessPlanItems = createSelector(
  [getBusinessPlan],
  (businessPlanItems: any) => businessPlanItems,
) as any;

export const getBusinessPlanSelectedCurrency = createSelector(
  [getBusinessPlan, getDashboardDropdowns, getProfile],
  ({ currencyCodesId }, { inputCurrencies }, { businessAddress }) => {
    const defaultCurrency = getCurrencyByCountry(
      businessAddress?.countryIsocode as CountryISOCodes,
    );

    return (
      inputCurrencies.find((cur) => cur.currencyCodeID === currencyCodesId)
        ?.alphaCode || defaultCurrency
    );
  },
);

export const getIsLoading = createSelector(
  [getRoot],
  ({ isLoading }) => isLoading,
);

export const getIsLogoUpload = createSelector(
  [getRoot],
  ({ isLogoUpload }) => isLogoUpload,
);

export const getIsDownalod = createSelector(
  [getRoot],
  ({ isDownalod }) => isDownalod,
);

export const getIsDocumentLoading = createSelector(
  [getRoot],
  ({ isDocumentLoading }) => isDocumentLoading,
);

export const getIsBusinessPlanLoading = createSelector(
  [getRoot],
  ({ isBusinessPlanLoading }) => isBusinessPlanLoading,
);

export const getDropdowns = createSelector(
  [getRoot],
  ({
    industryTypes,
    geogrphicTypes,
    demographicTypes,
    merchantCategoryCodes,
  }) => ({
    industryTypes,
    geogrphicTypes,
    demographicTypes,
    merchantCategoryCodes,
  }),
);

export const getSelectedValue = (id, listKey, valueKey) => {
  return createSelector([getDropdowns], (list) =>
    list[listKey].find((items) => items[valueKey] === id),
  );
};
